export const ORDERS_PICKUP_DATE_FORMAT = 'h:mm A (MMMM D, YYYY)';
export const ORDERS_PAYMENT_DATE_FORMAT = 'DD.MM.YYYY HH:mm:ss';
